import React, { useEffect, useState } from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
} from "@mui/material";

const AddEditPatientCheckboxField = ({ metadata, data, setMetadata }) => {
  const [checkboxValue, setCheckboxValue] = useState({});

  const handleCheckBoxChange = (event) => {
    const { name, checked } = event.target;
    setMetadata({
      ...metadata,
      [data.legend]: { ...metadata[data.legend], [name]: checked },
    });
  };

  useEffect(() => {
    if (metadata[data.legend]) {
      setCheckboxValue(metadata[data.legend]);
    }
  }, [metadata,data]);

  return (
    <Grid xs={12} item>
      <FormControl component="fieldset" variant="standard">
        <FormLabel component="legend" className="add-edit-checkbox-legend">
          {data.legend}
        </FormLabel>
        <FormGroup>
          {data?.checkboxes?.map((item) => (
            <FormControlLabel
              control={
                <Checkbox
                  checked={checkboxValue?.[item.name] || false}
                  onChange={handleCheckBoxChange}
                  name={item.name}
                />
              }
              label={item.label}
              key={item.name}
              className="add-edit-checkbox"
            />
          ))}
        </FormGroup>
      </FormControl>
    </Grid>
  );
};

export default AddEditPatientCheckboxField;
